import React from 'react';
import './styles.css';

const ErrorPage = ({ error, resetErrorBoundary }) => {
  console.log('Terjadi error:', error);
  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-illustration">
          <svg
            width="200"
            height="200"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
            <path
              d="M8 8L16 16M16 8L8 16"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <h1 className="error-title">Oops! Terjadi Kesalahan</h1>
        <p className="error-description">
          Mohon maaf, sepertinya ada masalah dalam memproses permintaan Anda.
          {/*{error?.message && (
            <span className="error-details">Detail: {error.message}</span>
          )}*/}
        </p>
        <div className="error-actions">
          <button
            className="retry-button primary"
            onClick={resetErrorBoundary}
          >
            Coba Lagi
          </button>
          <button
            className="home-button secondary"
            onClick={() => window.location.href = '/'}
          >
            Kembali ke Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;